import axios from 'axios';
import requestInterceptor from './requestInterceptor';

const defaultMimeType = 'application/json';

const licenseApiInstance = axios.create({
  baseURL: process.env.API_URL,
  timeout: 30000,
  headers: { 'Content-Type': defaultMimeType, Accept: defaultMimeType }
});

// Add a request interceptor
licenseApiInstance.interceptors.request.use(requestInterceptor);

export default licenseApiInstance;



// WEBPACK FOOTER //
// ./src/common/api/licenseApi.js